module.exports = __webpack_public_path__ + "static/img/off-4p.f7a60f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newHome/village/off-4p.png
// module id = 2TRy
// module chunks = 1